import React, { useEffect, useState } from "react";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from "@mui/material";
import CustomButton from "../../components/customButton";
import TextInput from "../../components/textInput";

const initialFormState = {
  locationName: "",
  locationAddress: "",
  locationNumber: "",
  instructions: "",
};

const AddSubtaskModal = ({ open, onClose, onSubmit, loading }) => {
  const [formData, setFormData] = useState(initialFormState);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (!open) {
      setFormData(initialFormState);
      setErrors({});
    }
  }, [open]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const validateForm = () => {
    const nextErrors = {};
    if (!formData.locationName.trim()) nextErrors.locationName = "Location name is required";
    if (!formData.locationAddress.trim()) nextErrors.locationAddress = "Location address is required";
    if (!formData.locationNumber.trim()) nextErrors.locationNumber = "Location number is required";
    return nextErrors;
  };

  const handleSubmit = () => {
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length) {
      setErrors(validationErrors);
      return;
    }
    onSubmit({
      locationName: formData.locationName.trim(),
      locationAddress: formData.locationAddress.trim(),
      locationNumber: formData.locationNumber.trim(),
      instructions: formData.instructions.trim(),
    });
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          borderRadius: "20px",
        },
      }}
    >
      <DialogTitle>Add Subtask</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} mt={0.5}>
          <Grid item xs={12}>
            <TextInput
              label="Location Name"
              name="locationName"
              value={formData.locationName}
              onChange={handleChange}
              placeholder="Enter location name"
            />
            {errors.locationName && <Box color="error.main" fontSize={12} mt={0.5}>{errors.locationName}</Box>}
          </Grid>
          <Grid item xs={12}>
            <TextInput
              label="Location Address"
              name="locationAddress"
              value={formData.locationAddress}
              onChange={handleChange}
              placeholder="Enter location address"
            />
            {errors.locationAddress && <Box color="error.main" fontSize={12} mt={0.5}>{errors.locationAddress}</Box>}
          </Grid>
          <Grid item xs={12}>
            <TextInput
              label="Location Number"
              name="locationNumber"
              value={formData.locationNumber}
              onChange={handleChange}
              placeholder="Enter location number"
            />
            {errors.locationNumber && <Box color="error.main" fontSize={12} mt={0.5}>{errors.locationNumber}</Box>}
          </Grid>
          <Grid item xs={12}>
            <TextInput
              label="Instructions"
              name="instructions"
              value={formData.instructions}
              onChange={handleChange}
              placeholder="Enter instructions"
              multiline
              rows={3}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Box display="flex" gap={1} width="100%" justifyContent="flex-end">
          <CustomButton
            btnLabel="Cancel"
            handlePressBtn={onClose}
            btnBgColor="#fff"
            btnTextColor="#225B27"
            borderColor="#225B27"
            isBorder="1px solid #225B27"
          />
          <CustomButton
            btnLabel="Add Subtask"
            handlePressBtn={handleSubmit}
            btnBgColor="#225B27"
            btnTextColor="#fff"
            disabled={loading}
          />
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default AddSubtaskModal;
